// Reading and clearing the uncontrolled value inputs of ValueInputs.
import type { ValueShape } from "./templates";

/** Read one value input of a submitted form by its name. */
export function formReader(form: HTMLFormElement): (name: string) => string {
  const data = new FormData(form);
  return (name) => {
    const v = data.get(name);
    return typeof v === "string" ? v : "";
  };
}

/** Empty the value inputs once the value is sealed and sent. */
export function clearValues(form: HTMLFormElement, shape: ValueShape): void {
  const names = shape.kind === "named" ? shape.fields.map((f) => f.name) : ["value"];
  for (const name of names) {
    const input = form.elements.namedItem(name);
    if (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) input.value = "";
  }
}
